<template>
  <BaseDialog
    type="basic"
    :is-open="isOpen"
    @close="$emit('closeDialog')"
    :title="`Datum setzen für ${coachee.firstName}`"
    ><div class="flex flex-col gap-4">
      <BaseDatePicker
        v-model="plannedAt"
        label="Datum des Dialogs"
        required
        class="bg-surface-container-high"
      />
      <div
        v-if="plannedAt && !dialog.coacheeDataReleasedAt"
        class="bg-surface-container-low rounded-large p-4"
      >
        <h3 class="text-title-small">Vorlaufzeit</h3>
        <p class="text-body-medium text-on-surface-variant">
          Bis zu diesem Zeitpunkt muss {{ coachee.firstName }} den Dialog vorbereiten und für dich
          freigeben.
        </p>
        <div class="mt-4 flex flex-row gap-2">
          <BaseMenu
            :items="
              Object.values(DialogLeadTimeOption).map((option) => ({
                id: option,
                title: $t('dialog.lead-time-option.' + option),
                leadingIcon: option == leadTimeOption ? 'check' : undefined,
                callback: () => {
                  leadTimeOption = option
                },
              }))
            "
          >
            <template v-slot="{ open }">
              <BaseChip type="filter" :menu="open ? 'open' : 'close'">{{
                $t('dialog.lead-time-option.' + leadTimeOption)
              }}</BaseChip>
            </template>
          </BaseMenu>
          <BaseDatePicker
            v-if="leadTimeOption == DialogLeadTimeOption.Custom"
            v-model="leadTimeCustomDate"
            label="Zeitpunkt"
            :max-date="plannedAt"
            class="bg-surface-container-low -mt-2"
          />
        </div>
      </div>
    </div>
    <template #dismiss
      ><BaseTextButton @click="emits('closeDialog')">{{
        $t('common.cancel')
      }}</BaseTextButton></template
    >
    <template #confirm><BaseTextButton @click="update">Datum setzen</BaseTextButton></template>
  </BaseDialog>
</template>

<script setup lang="ts">
  import BaseTextButton from '../../../core/components/base/button/text-button/BaseTextButton.vue'
  import BaseChip from '../../../core/components/base/chip/BaseChip.vue'
  import BaseDatePicker from '../../../core/components/base/date-picker/BaseDatePicker.vue'
  import BaseDialog from '../../../core/components/base/dialog/BaseDialog.vue'
  import BaseMenu from '../../../core/components/base/menu/BaseMenu.vue'
  import type { DialogInOverview } from '@/modules/coachees/composables/useCoacheeDialogs'
  import { DialogLeadTimeOption, useUpdateDialog } from '../composables/useUpdateDialog'
  import type { MemberOrUser } from '@/core/models/member/member-or-user'

  interface Props {
    dialog: DialogInOverview
    coachee: MemberOrUser
    isOpen: boolean
  }

  const emits = defineEmits<{
    (e: 'closeDialog'): void
    (e: 'dateSet'): void
  }>()

  const { dialog, coachee } = defineProps<Props>()

  const { plannedAt, update, leadTimeOption, leadTimeCustomDate } = useUpdateDialog(
    {
      createdAt: dialog.createdAt,
      id: dialog.id,
      memberId: coachee.id,
      coacheeDataReleasedAt: dialog.coacheeDataReleasedAt,
      leadTimeOption: dialog.leadTimeOption,
      leadTimeStartsAt: dialog.leadTimeStartsAt,
      plannedAt: dialog.plannedAt,
    },
    () => {
      emits('closeDialog')
      emits('dateSet')
    },
  )
</script>
